module.exports = __webpack_public_path__ + "img/3S.1da91887.svg";